export default __webpack_public_path__ + "static/media/SndLowerKSlideAway.07dce3d8.mp3";